import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { NavLink } from '../nav-links.model';
import { Observable } from 'rxjs';
import { IBiographic } from '../../biographics/biographics.model';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { PendingCollectionService } from '../../../services/pending-collection.service';
import { Pending } from '../../biographics/pending.model';
import { PreviousRouteService } from '../previous-route.service';
import { map } from 'rxjs/operators';
import { filterEmptyValue } from '../../../rxjs-operators';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { EcaMonotronModule } from '@drc-eca/eca-components-lib';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'eca-review-edit-nav',
  templateUrl: './review-edit-nav.component.html',
  styleUrls: ['./review-edit-nav.component.scss'],
  imports: [EcaMonotronModule, RouterLink, MatTabGroup, MatTab, RouterOutlet, AsyncPipe]
})
export class ReviewEditNavComponent implements OnInit, AfterViewInit {
  route = inject(ActivatedRoute);
  pendingService = inject(PendingCollectionService);
  previousRouteService = inject(PreviousRouteService);
  private router = inject(Router);


  @ViewChild('navTabGroup')
    tabsComponent: MatTabGroup;
  selectedIndex = 0;

  biographic: IBiographic;
  pendingId: string;
  sortKey: string;
  bookId: string;

  previousUrl: string;
  submitText: string;

  navLinks: NavLink[] = [];

  pending$: Observable<Pending>;
  disableAlertsTab$: Observable<boolean>;

  constructor() {
    this.submitText = 'Submit';
  }

  ngOnInit() {
    const {pendingId} = this.route.snapshot.params;
    this.pendingId = pendingId;
    this.pending$ = this.pendingService.getPending(pendingId);
    this.disableAlertsTab$ = this.pending$.pipe(
      filterEmptyValue(),
      map((pending) => !pending.hasAlerts()),
    );

    this.initNav();

    this.previousRouteService.navigationUrls$.subscribe((navUrls) => {
      const newRouteLink = this.previousRouteService.processBiographicsAlertsRouteEvent(navUrls);
      this.previousUrl = newRouteLink.newPreviousUrl;
      this.submitText = newRouteLink.newLinkLabelText;
    });
  }

  initNav() {
    this.navLinks = [
      {
        label: 'Edit Biographical',
        path: `/biographic/${this.pendingId}/edit`,
      },
      {
        label: 'Alert Review',
        path: `/biographic/${this.pendingId}/review`,
        disabled$: this.disableAlertsTab$,
      },
    ];

    const lastUrlSegment = this.router.url.split('?')[0].split('/').pop();

    for (let index = 0; index < this.navLinks.length; index++) {
      if (this.navPathEndsWith(index, lastUrlSegment)) {
        this.selectedIndex = index;
        break;
      }
    }
  }

  navPathEndsWith(index: number, segment: string): boolean {
    return this.navLinks[index].path.endsWith(segment);
  }

  ngAfterViewInit(): void {
    this.tabsComponent.selectedIndex = this.selectedIndex;
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.router.navigate([this.navLinks[event.index].path]).catch(console.log);
  }

}
